<a class="download-button" (click)="download()">
	<mat-icon [ngClass]="{'hide': this.downloadGenerate}">get_app</mat-icon>
	<mat-icon class="spin" [ngClass]="{'hide': !this.downloadGenerate}">cached</mat-icon>
</a>
